import { LOGIN } from '../actions/actionTypes';

const initialState = {
  isLoggedIn: false,
  demo: false,
  email: '',
  demoAnimation: true,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        isLoggedIn: true,
        email: action.payload.email,
        demo: action.payload.demo,
        demoAnimation: action.payload.demoAnimation,
      };
    default:
      return state;
  }
};

export default authReducer;
